module.exports = __webpack_public_path__ + "img/mc.d62335be.svg";